/**
 * Historical compatibility seam. Registered V2 destinations must remain
 * reachable in production: maturity is never a reason to block a V2 route or
 * silently hand it off to V1. The standalone V1 remains available only through
 * the explicit version switch. The route audit keeps both collections empty.
 */
const freeze = (values) => Object.freeze([...values]);

export const LEGACY_ENGINE_ROUTE_DESTINATIONS = Object.freeze({});

/**
 * Kept as an empty exported collection for callers and historical tests. A
 * review-required status is documentation, never a runtime disablement.
 */
export const UNVERIFIED_NATIVE_V2_DESTINATIONS = freeze([]);

export const LEGACY_ENGINE_PREVIEW_BLOCKLIST = freeze(
  [...new Set([
    ...Object.values(LEGACY_ENGINE_ROUTE_DESTINATIONS).flat(),
    ...UNVERIFIED_NATIVE_V2_DESTINATIONS,
  ])].sort()
);
